import { DecisionTreeActionType } from 'redux/actions/decisionTreeActions';
import {
  CREATE_CASE_END,
  FINISH_DECISION_TREE,
  GET_FIRST_DECISION_TREE_STEP,
  GET_QUESTIONS_DECISION_TREE_SUCCESS,
  REMOVE_STEP_FROM_CURRENT_DT_PATH,
  UPDATE_CURRENT_DECISION_TREE_STEP,
} from '../actions/types';
import {
  CurrentStepAnswerType,
  DecisionTreeCurrentStepState,
  DTAnswerTypes,
  QuestionType,
} from 'ts/types/decision-tree.types';
import {
  computableContractsIconAdapter,
  iconsAdapter,
  isValueInSomeIcons,
} from 'components/Icons/utils';
import { StringMap } from 'ts/types/common.types';

export const initState: DecisionTreeCurrentStepState = {
  currentOption: {
    id: '',
    allowMultiplePerClaim: false,
    answers: [],
    displayName: '',
    metadata: [],
    possibleAnswers: [],
    priority: 0,
    source: '',
    type: DTAnswerTypes.TEXT,
  },
  ready: false,
};

const pruneIcons = (children: CurrentStepAnswerType[]) => {
  if (
    !children.some(
      ({ icon }: { icon?: string }) =>
        icon && Object.keys(iconsAdapter).includes(icon.toUpperCase()),
    )
  ) {
    children.forEach((child: any) => {
      delete child.icon;
    });
  }
};

const setIcon = (
  metadata: { [_: string]: string }[] | undefined,
  id: string,
) => {
  let toReturn = ' ';
  const iconValue = metadata
    ? metadata?.find((meta: StringMap) => meta.key === 'icon')?.value
    : computableContractsIconAdapter[id];
  if (iconValue && isValueInSomeIcons(iconValue)) {
    toReturn = iconValue;
  }
  return toReturn;
};

const getAnswers = (rawCurrentOption: QuestionType) => {
  let answers: any[];
  switch (rawCurrentOption.type) {
    case DTAnswerTypes.ENUM:
      answers = rawCurrentOption.answers
        .filter(({ id }) => rawCurrentOption.possibleAnswers?.includes(id))
        .map(({ id, metadata, ...rest }: CurrentStepAnswerType) => ({
          id,
          ...rest,
          icon: setIcon(metadata, id),
        }));
      pruneIcons(answers);
      break;
    case DTAnswerTypes.DATE:
      answers = [
        {
          id: new Date().toISOString(),
        },
      ];
      break;
    case DTAnswerTypes.BOOLEAN:
      answers = [
        {
          displayName: 'decision_tree-true',
          id: 'true',
        },
        {
          displayName: 'decision_tree-false',
          id: 'false',
        },
      ];
      break;
    case DTAnswerTypes.LOCATION:
    case DTAnswerTypes.NUMBER:
    case DTAnswerTypes.TEXT:
      answers = [
        {
          id: '',
        },
      ];
      break;
    default:
      answers = [];
      break;
  }
  return answers;
};

function decisionTreeCurrentStepReducer(
  state: DecisionTreeCurrentStepState = initState,
  action: DecisionTreeActionType,
): any {
  switch (action.type) {
    case UPDATE_CURRENT_DECISION_TREE_STEP:
    case GET_QUESTIONS_DECISION_TREE_SUCCESS:
      if (!action.payload.response?.nextQuestion) {
        return state;
      }
      const rawCurrentOption = action.payload.response?.nextQuestion;
      const answers = getAnswers(rawCurrentOption);
      const currentOption = { ...rawCurrentOption, answers };
      return { ...state, currentOption };
    case FINISH_DECISION_TREE:
      return { ...state, ready: true };
    case GET_FIRST_DECISION_TREE_STEP:
    case REMOVE_STEP_FROM_CURRENT_DT_PATH:
      return { ...state, ready: false };
    case CREATE_CASE_END:
      return initState;
    default:
      return state;
  }
}

export default decisionTreeCurrentStepReducer;
